import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const FactoryFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path
        fillRule="evenodd"
        d="M7.83835 11.7127L6.66542 4.80078H4.17293L3 11.7127H7.83835ZM15.24 19.5005H9.75H9.4801H3.00026L3 13.5005H9.4801V8.17578L15.2402 12.0007L15.2402 8.17578L21.0002 12.0007V19.5005H15.2402H15.24ZM16.8752 17.8204V13.5005H19.1252V17.8204H16.8752ZM11.2502 13.5005H13.5002V17.8204H11.2502V13.5005Z"
      />
    </SvgIcon>
  );
});
